export enum CachingStepNames {
  SelectConnection = "Select Connection",
  AddTables = "Add Tables",
  ScheduleJobs = "Schedule Jobs",
}
